var OrganizationService = /** @class */ (function () {
    function OrganizationService(api) {
        this.API = api;
    }
    OrganizationService.prototype.listOrganizations = function () {
        var url = '/organizations/me';
        return this.API.get(url);
    };
    OrganizationService.prototype.listPendingOrganizations = function () {
        var url = '/organizations/pending/';
        return this.API.get(url);
    };
    OrganizationService.prototype.cancelPendingOrganizations = function (organizationId) {
        var url = "/organizations/pending/cancel?organization=".concat(organizationId);
        return this.API.delete(url);
    };
    OrganizationService.prototype.confirmPendingOrganizations = function (organizationId) {
        var url = "/organizations/pending/confirm?organization=".concat(organizationId);
        return this.API.patch(url);
    };
    OrganizationService.prototype.getPendingOrganizationDetails = function (organizationId) {
        var url = "/organizations/pending/".concat(organizationId);
        return this.API.get(url);
    };
    OrganizationService.prototype.savePendingOrganizationDetails = function (organizationId, data) {
        var url = "/organizations/pending/".concat(organizationId);
        return this.API.patch(url, data);
    };
    OrganizationService.prototype.listOrganizationswithAppWritePerm = function () {
        var url = '/organizations/apps';
        return this.API.get(url);
    };
    OrganizationService.prototype.createOrganization = function (organizationId) {
        var url = "/organizations";
        return this.API.post(url, organizationId, { noOrgHeader: true });
    };
    OrganizationService.prototype.checkForOrganizationNumber = function (companyNumber, id, companyName, name) {
        var url = "/organizations/number";
        var pushObject = {
            id: id,
            company_number: companyNumber,
            company_name: companyName,
            name: name,
        };
        return this.API.post(url, pushObject, { noOrgHeader: true });
    };
    OrganizationService.prototype.addUserToOrganization = function (organizationId, user) {
        var url = "/organizations/".concat(organizationId, "/members");
        return this.API.post(url, user);
    };
    OrganizationService.prototype.getOrganizationMembers = function (organizationId) {
        var url = "/organizations/".concat(organizationId, "/members");
        return this.API.get(url);
    };
    OrganizationService.prototype.getOrganizationCategories = function (organizationId) {
        var url = "/organizations/".concat(organizationId, "/category");
        return this.API.get(url);
    };
    OrganizationService.prototype.addOrganizationCategory = function (organizationId, category) {
        var url = "/organizations/".concat(organizationId, "/category");
        return this.API.post(url, category);
    };
    OrganizationService.prototype.updateOrganizationCategory = function (organizationId, category, categoryId) {
        var url = "/organizations/".concat(organizationId, "/category/").concat(categoryId);
        return this.API.patch(url, category);
    };
    OrganizationService.prototype.deleteOrganizationCategory = function (organizationId, categoryId, templateId) {
        var url = "/organizations/".concat(organizationId, "/category/").concat(categoryId);
        if (templateId) {
            url = "/organizations/".concat(organizationId, "/category/").concat(categoryId, "?template=").concat(templateId);
        }
        return this.API.delete(url);
    };
    OrganizationService.prototype.removeUsersFromOrganization = function (organizationId, selectedUserIds) {
        var url = "/organizations/".concat(organizationId, "/members/remove");
        var userIds = {
            user_ids: selectedUserIds,
        };
        return this.API.post(url, userIds);
    };
    OrganizationService.prototype.removeMemberFromOrganization = function (organizationId, selectedUserId) {
        var url = "/organizations/".concat(organizationId, "/members/remove/").concat(selectedUserId);
        return this.API.delete(url);
    };
    OrganizationService.prototype.getOrganizationDetails = function (organizationId) {
        var url = "/organizations/".concat(organizationId);
        return this.API.get(url);
    };
    OrganizationService.prototype.deleteOrganization = function (organizationId) {
        var url = "/organizations/".concat(organizationId);
        return this.API.delete(url);
    };
    OrganizationService.prototype.updateOrganizationInfo = function (organizationId, organization) {
        var url = "/organizations/".concat(organizationId);
        return this.API.patch(url, organization);
    };
    OrganizationService.prototype.updateOrganizationBundleAccess = function (organizationId, publicBundleAccess) {
        var url = "/organizations/partner/".concat(organizationId);
        return this.API.patch(url, { public_bundle_access: publicBundleAccess });
    };
    OrganizationService.prototype.checkCardSignup = function () {
        var url = "/signup/payment/check";
        return this.API.get(url);
    };
    OrganizationService.prototype.assignPaymentMethodToOrganization = function (organizationId, paymentMethodId) {
        var url = "/organizations/".concat(organizationId, "/payment/assign");
        var body = {
            payment_method_id: paymentMethodId,
        };
        return this.API.post(url, body);
    };
    OrganizationService.prototype.getClientSecret = function (organizationId, bundleId) {
        var url = "/organizations/".concat(organizationId, "/payment/purchase");
        var body = {
            bundle_id: bundleId,
        };
        return this.API.post(url, body);
    };
    OrganizationService.prototype.createInvoice = function (organizationId, bundleId) {
        var url = "/organizations/".concat(organizationId, "/payment/invoice");
        var body = {
            bundle_id: bundleId,
        };
        return this.API.post(url, body);
    };
    OrganizationService.prototype.changeDefaultPaymentMethod = function (organizationId, paymentMethod) {
        var url = "/organizations/partner/".concat(organizationId, "/payment");
        var body = {
            default_payment_method: paymentMethod,
        };
        return this.API.patch(url, body);
    };
    OrganizationService.prototype.getProratedAmountForAddons = function (organizationId, bundles) {
        var url = "/organizations/".concat(organizationId, "/topups/proration");
        var body = bundles;
        return this.API.patch(url, body);
    };
    OrganizationService.prototype.getResellerDetailsForManagedOrg = function (organizationId) {
        var url = "/organizations/".concat(organizationId, "/managed/reseller");
        return this.API.get(url);
    };
    OrganizationService.prototype.checkOrganizationStatus = function (organizationId) {
        var url = "/organizations/".concat(organizationId, "/status");
        return organizationId !== 'shared' ? this.API.get(url) : null;
    };
    return OrganizationService;
}());
export { OrganizationService };
